import * as profileTypes from "./profile.type";

const initialState = {
  profileDetail: null,
  address: null,
  deleteAddressResponse: null,
  changeAddressStatusResponse: null,
  selectedAddress: null,
  countryList: null,
  provinceList: null,
  countyList: null,
  districtList: null,
  subjectList: null,
  contactUsTree: null,
  subjectDetail: null,
  sendMessage: null,
  changePassword: null,
  profileImageUpload: null,
  pointHistoryAll: null,
  charityScore: null,
  pointHistoryCollected: null,
  pointHistorySpent: null,
  profilePhoto: null,
  responseImageUpload: null,
  orderList: [],
  brandOrderList: [],
  notification: [],
  tenantMenu: null,
  score: null,
  monthlyBuy: null,
  monthlyIncome: null,
  productFound: null,
  percentage: null,
  focusInfo: null,
  error: null,
  isLoading: false,
  saveInvoice: null,
  uploadInvoice: null,
  receiptList: [],
  performanceDashboard: null,
  myReferencesList: null,
  businessInviteInfo: null,
  myBusinessReferences: null,
};

const reducer = (state = initialState, { type, payload, ...params }) => {
  switch (type) {
    case `${profileTypes.SET_CHANGE_PASSWORD_PENDING}`:
    case `${profileTypes.SET_ADDRESS_PENDING}`:
    case `${profileTypes.GET_ADDRESSES_PENDING}`:
    case `${profileTypes.DELETE_ADDRESS_PENDING}`:
    case `${profileTypes.SET_ADDRESS_STATUS_PENDING}`:
    case `${profileTypes.GET_COUNTRY_PENDING}`:
    case `${profileTypes.GET_PROVINCE_PENDING}`:
    case `${profileTypes.GET_COUNTY_PENDING}`:
    case `${profileTypes.GET_DISTRICT_PENDING}`:
    case `${profileTypes.GET_SUBJECT_LIST_PENDING}`:
    case `${profileTypes.GET_SUBJECT_BY_ID_PENDING}`:
    case `${profileTypes.SET_SEND_MESSAGE_PENDING}`:
    case `${profileTypes.GET_LOGIN_USER_DETAIL_PENDING}`:
    case `${profileTypes.SET_PROFILE_IMAGE_UPLOAD_PENDING}`:
    case `${profileTypes.GET_PROFILE_SCORE_HISTORY_ALL_PENDING}`:
    case `${profileTypes.GET_PROFILE_SCORE_HISTORY_COLLECTED_PENDING}`:
    case `${profileTypes.GET_PROFILE_SCORE_HISTORY_SPENT_PENDING}`:
    case `${profileTypes.GET_PROFILE_USER_IMAGE_PENDING}`:
    case `${profileTypes.REMOVE_IMAGE_PENDING}`:
    case `${profileTypes.GET_ORDER_LIST_PENDING}`:
    case `${profileTypes.GET_USERS_SCORE_PENDING}`:
    case `${profileTypes.GET_TENANT_MENU_PENDING}`:
    case `${profileTypes.GET_MONTHLY_PERFORMANCE_PENDING}`:
    case `${profileTypes.GET_MONTHLY_INCOME_PERFORMANCE_PENDING}`:
    case `${profileTypes.GET_PRODUCT_FOUND_PERFORMANCE_PENDING}`:
    case `${profileTypes.GET_PERCENTAGE_PERFORMANCE_PENDING}`:
    case `${profileTypes.GET_FOCUS_INFO_PERFORMANCE_PENDING}`:
    case `${profileTypes.GET_NOTIFICATIONS_PENDING}`:
    case `${profileTypes.MARK_NOTIFICATION_READ_PENDING}`:
    case `${profileTypes.POST_2FA_CONTROL_PENDING}`:
    case `${profileTypes.GET_USERS_CHARITY_SCORE_PENDING}`:
    case `${profileTypes.SPEND_GIFT_CODE_PENDING}`:
    case `${profileTypes.SAVE_INVOICE_PENDING}`:
    case `${profileTypes.UPLOAD_INVOICE_PENDING}`:
    case `${profileTypes.GET_RECEIPT_LIST_PENDING}`:
    case `${profileTypes.GET_PERFORMANCE_DASHBOARD_PENDING}`:
    case `${profileTypes.GET_MY_REFERENCES_LIST_PENDING}`:
      return { ...state, isLoading: true, error: null };
    case `${profileTypes.GET_NOTIFICATIONS_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        notification: payload.data,
      };
    case `${profileTypes.GET_NOTIFICATIONS_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        notification: null,
      };

    case `${profileTypes.GET_LOGIN_USER_DETAIL_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        profileDetail: payload.data,
      };
    case `${profileTypes.GET_LOGIN_USER_DETAIL_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        profileDetail: null,
      };

    case `${profileTypes.SET_ADDRESS_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        selectedAddress: payload.data,
      };
    case `${profileTypes.SET_ADDRESS_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        selectedAddress: null,
      };

    case `${profileTypes.GET_ADDRESSES_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        address: payload.data,
      };
    case `${profileTypes.GET_ADDRESSES_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        address: null,
      };

    case `${profileTypes.DELETE_ADDRESS_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        deleteAddressResponse: payload.data,
      };
    case `${profileTypes.DELETE_ADDRESS_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        deleteAddressResponse: null,
      };

    case `${profileTypes.SET_ADDRESS_STATUS_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        changeAddressStatusResponse: payload.data,
      };
    case `${profileTypes.SET_ADDRESS_STATUS_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        changeAddressStatusResponse: null,
      };

    case `${profileTypes.GET_COUNTRY_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        countryList: payload.data,
      };
    case `${profileTypes.GET_COUNTRY_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        countryList: null,
      };

    case `${profileTypes.GET_PROVINCE_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        provinceList: payload.data,
      };
    case `${profileTypes.GET_PROVINCE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        provinceList: null,
      };

    case `${profileTypes.GET_COUNTY_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        countyList: payload?.data,
      };
    case `${profileTypes.GET_COUNTY_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        countyList: null,
      };

    case `${profileTypes.GET_DISTRICT_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        districtList: payload?.data,
      };
    case `${profileTypes.GET_DISTRICT_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        districtList: null,
      };

    case `${profileTypes.GET_SUBJECT_LIST_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        subjectList: payload.data,
      };
    case `${profileTypes.GET_SUBJECT_LIST_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        subjectList: null,
      };

    case `${profileTypes.GET_CONTACT_US_TREE_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        contactUsTree: payload.data,
      };
    case `${profileTypes.GET_CONTACT_US_TREE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        contactUsTree: null,
      };

    case `${profileTypes.GET_SUBJECT_BY_ID_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        subjectDetail: payload.data,
      };
    case `${profileTypes.GET_SUBJECT_BY_ID_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        subjectDetail: null,
      };

    case `${profileTypes.SET_SEND_MESSAGE_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        sendMessage: payload.data,
      };
    case `${profileTypes.SET_SEND_MESSAGE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        sendMessage: null,
      };

    case `${profileTypes.SET_CHANGE_PASSWORD_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        changePassword: payload.data,
      };
    case `${profileTypes.SET_CHANGE_PASSWORD_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        changePassword: null,
      };

    case `${profileTypes.SET_PROFILE_IMAGE_UPLOAD_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        changePassword: payload.data,
      };
    case `${profileTypes.SET_PROFILE_IMAGE_UPLOAD_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        changePassword: null,
      };

    case `${profileTypes.GET_PROFILE_SCORE_HISTORY_ALL_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        pointHistoryAll: payload.data,
      };
    case `${profileTypes.GET_PROFILE_SCORE_HISTORY_ALL_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        pointHistoryAll: null,
      };

    case `${profileTypes.GET_USERS_CHARITY_SCORE_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        charityScore: payload.data,
      };
    case `${profileTypes.GET_USERS_CHARITY_SCORE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        charityScore: null,
      };

    case `${profileTypes.GET_PROFILE_SCORE_HISTORY_COLLECTED_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        pointHistoryCollected: payload.data,
      };
    case `${profileTypes.GET_PROFILE_SCORE_HISTORY_COLLECTED_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        pointHistoryCollected: null,
      };

    case `${profileTypes.GET_PROFILE_SCORE_HISTORY_SPENT_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        pointHistorySpent: payload.data,
      };
    case `${profileTypes.GET_PROFILE_SCORE_HISTORY_SPENT_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        pointHistorySpent: null,
      };

    case `${profileTypes.GET_PROFILE_USER_IMAGE_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        profilePhoto: payload.data,
      };

    case `${profileTypes.GET_PROFILE_USER_IMAGE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload.data,
        profilePhoto: null,
      };

    case `${profileTypes.REMOVE_IMAGE_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
      };

    case `${profileTypes.REMOVE_IMAGE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload.data,
      };

    case `${profileTypes.IMAGE_UPLOAD_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        responseImageUpload: payload.data,
      };

    case `${profileTypes.IMAGE_UPLOAD_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload.data,
        responseImageUpload: null,
      };

    case `${profileTypes.GET_ORDER_LIST_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        orderList: payload.data,
      };

    case `${profileTypes.GET_ORDER_LIST_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload.data,
        orderList: [],
      };

    case `${profileTypes.GET_BRAND_ORDER_LIST_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        brandOrderList: payload.data,
      };

    case `${profileTypes.GET_BRAND_ORDER_LIST_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload.data,
        brandOrderList: [],
      };

    case `${profileTypes.GET_USERS_SCORE_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        score: payload.data,
      };

    case `${profileTypes.GET_USERS_SCORE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload.data,
        score: null,
      };

    case `${profileTypes.GET_TENANT_MENU_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        tenantMenu: payload.data,
      };

    case `${profileTypes.GET_TENANT_MENU_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload.data,
        tenantMenu: null,
      };

    case `${profileTypes.GET_MONTHLY_PERFORMANCE_FULFILLED}`:
      return {
        ...state,
        monthlyBuy: payload,
        isLoading: false,
      };
    case `${profileTypes.GET_MONTHLY_PERFORMANCE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case `${profileTypes.GET_MONTHLY_INCOME_PERFORMANCE_FULFILLED}`:
      return {
        ...state,
        monthlyIncome: payload,
        isLoading: false,
      };
    case `${profileTypes.GET_MONTHLY_INCOME_PERFORMANCE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case `${profileTypes.GET_PRODUCT_FOUND_PERFORMANCE_FULFILLED}`:
      return {
        ...state,
        productFound: payload,
        isLoading: false,
      };
    case `${profileTypes.GET_PRODUCT_FOUND_PERFORMANCE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case `${profileTypes.GET_PERCENTAGE_PERFORMANCE_FULFILLED}`:
      return {
        ...state,
        percentage: payload,
        isLoading: false,
      };
    case `${profileTypes.GET_PERCENTAGE_PERFORMANCE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case `${profileTypes.GET_FOCUS_INFO_PERFORMANCE_FULFILLED}`:
      return {
        ...state,
        focusInfo: payload,
        isLoading: false,
      };
    case `${profileTypes.GET_FOCUS_INFO_PERFORMANCE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case `${profileTypes.POST_2FA_CONTROL_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
      };

    case `${profileTypes.POST_2FA_CONTROL_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case `${profileTypes.SPEND_GIFT_CODE_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
      };

    case `${profileTypes.SPEND_GIFT_CODE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case `${profileTypes.SAVE_INVOICE_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        saveInvoice: payload.data,
      };

    case `${profileTypes.SAVE_INVOICE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        saveInvoice: null,
      };

    case `${profileTypes.UPLOAD_INVOICE_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        uploadInvoice: payload.data,
      };

    case `${profileTypes.UPLOAD_INVOICE_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case `${profileTypes.GET_RECEIPT_LIST_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        receiptList: payload.data,
      };

    case `${profileTypes.GET_RECEIPT_LIST_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        receiptList: [],
      };

    case `${profileTypes.GET_PERFORMANCE_DASHBOARD_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        performanceDashboard: payload.data,
      };

    case `${profileTypes.GET_PERFORMANCE_DASHBOARD_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case `${profileTypes.GET_MY_REFERENCES_LIST_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        myReferencesList: payload.data,
      };

    case `${profileTypes.GET_MY_REFERENCES_LIST_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        myReferencesList: null,
      };

    case `${profileTypes.GET_BUSINESS_INVITE_INFO_PENDING}`:
      return { ...state, isLoading: true, error: null };

    case `${profileTypes.GET_BUSINESS_INVITE_INFO_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        businessInviteInfo: payload.data,
      };

    case `${profileTypes.GET_BUSINESS_INVITE_INFO_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        businessInviteInfo: null,
      };

    case `${profileTypes.GET_MY_BUSINESS_REFERENCES_PENDING}`:
      return { ...state, isLoading: true, error: null };

    case `${profileTypes.GET_MY_BUSINESS_REFERENCES_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        myBusinessReferences: payload.data,
      };

    case `${profileTypes.GET_MY_BUSINESS_REFERENCES_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        myBusinessReferences: null,
      };

    default:
      return state;
  }
};

export default reducer;
